<template>
  <div :class="['btn-style', isMobile ? '' : 'btn-style-pc']">
    <div class="nav-content">
      <div class="nav-title">{{ robotNav.tit }}</div>
      <div class="nav-list" :class="`nav-list-cnt-${robotNav.list.length}}`">
        <div
          v-for="(item, index) in robotNav.list"
          :key="index"
          class="nav-item"
        >
          <div class="nav-link" @click="onClick(item)">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotNavMixin from './robot-nav-mixin.js';
/**
 * @component 机器人导航 - 按钮型
 */
export default {
  mixins: [robotNavMixin],
};
</script>

<style lang="less" scoped>
.btn-style {
  .nav-content {
    border-radius: 6px;
    padding: 12px 16px 16px 16px;
    background-color: #ffffff;
    .nav-title {
      font-size: 14px;
      color: #78849e;
      line-height: 20px;
    }
    .nav-list {
      overflow: hidden;
      padding-top: 2px;
      display: flex;
      flex-wrap: wrap;
      .nav-item {
        flex: 0 0 49%;
        height: 30px;
        margin-top: 10px;
        margin-right: 2%;
        cursor: pointer;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .nav-link {
          display: block;
          line-height: 28px;
          border: 1px solid @primary;
          border-radius: 15px;
          font-size: 13px;
          color: @primary;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.btn-style-pc {
  width: 336px;
  .nav-content {
    border-radius: 6px;
    box-shadow: 0 1px 10px 0 #e1e6f0;
    margin-top: 2px;
    background-color: #fff;
  }
}
</style>
